module.exports = __webpack_public_path__ + "img/pueblos.o.1bf9595f.png";